import { stripeFgColor } from './StripeStore';

import { stripeFgColorDefault } from './StripeStoreDefaults';

export const resetStripeFgColor = () => stripeFgColor.set(stripeFgColorDefault);
